module.exports = __webpack_public_path__ + "static/media/COG.052db582.svg";